import { mmFetchWithResponse } from 'api/mmFetchWithResponse';

const CATALOG_SKU_EVENTS_PATH = 'api/warehouse/v1/catalog/external-skus';
export const DEFAULT_CATALOG_SKU_EVENTS_LIMIT = 100;
export const MAX_CATALOG_SKU_EVENTS_LIMIT = 200;

/**
 * @param {unknown} value
 * @returns {number | undefined}
 */
export function normalizeExternalSku(value) {
    if (value === undefined || value === null || value === '') {
        return undefined;
    }
    const n = Number(value);
    if (!Number.isInteger(n) || n <= 0) {
        return undefined;
    }
    return n;
}

/**
 * @param {unknown} value
 * @param {number} [fallback=DEFAULT_CATALOG_SKU_EVENTS_LIMIT]
 * @returns {number}
 */
export function normalizeCatalogSkuEventsLimit(value, fallback = DEFAULT_CATALOG_SKU_EVENTS_LIMIT) {
    const n = Number(value);
    if (!Number.isInteger(n) || n <= 0) {
        return fallback;
    }
    return Math.min(n, MAX_CATALOG_SKU_EVENTS_LIMIT);
}

/**
 * Fetches item master and item information modification events for an external SKU.
 *
 * GET /api/warehouse/v1/catalog/external-skus/{externalSku}/item-modification-events?limit=100
 *
 * @param {number | string} externalSku
 * @param {Object} [options={}]
 * @param {number} [options.limit]
 * @param {AbortSignal} [options.signal]
 * @returns {Promise<{status: boolean, msg?: string, data?: Object, statusCode?: number | null}>}
 */
export async function getCatalogItemModificationEvents(externalSku, options = {}) {
    const normalizedExternalSku = normalizeExternalSku(externalSku);
    if (normalizedExternalSku === undefined) {
        return Promise.resolve({
            status: false,
            msg: 'externalSku is invalid',
            data: {},
            statusCode: null,
        });
    }

    const { limit: requestedLimit, signal, ...restOptions } = options;
    const limit = normalizeCatalogSkuEventsLimit(requestedLimit);
    const url = `${CATALOG_SKU_EVENTS_PATH}/${normalizedExternalSku}/item-modification-events?limit=${limit}`;
    return mmFetchWithResponse(url, { signal, ...restOptions });
}
